import { useStatsigClient } from '@statsig/react-bindings';
import { useCallback } from 'react';

import { ExperimentLayers } from '../../statsig/experiments';

const [experimentName, { showSessionRecap }] = ExperimentLayers.ShowSessionRecapInTelehealth;

export function useGetShowSessionRecapExperimentCallback(): () => boolean {
  const { getExperiment } = useStatsigClient();

  return useCallback(
    () => getExperiment(experimentName).get<boolean>(showSessionRecap, false) ?? false,
    [getExperiment],
  );
}
